module.exports = __webpack_public_path__ + "img/powerAmplifier200w.582d138.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/powerAmplifier200w.png
// module id = lK09
// module chunks = 0